import React from 'react';

import { useHistory } from 'react-router-dom';
import { SideSpacer } from '../../components/common/Spacer';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import {
  CommonContainer,
  HistoryBlock,
  HistoryURL,
  HistoryActiveStyle,
  HorizonWrapper,
  HorizonContainer,
  NormalHistory,
  HistoryBtn
} from '../../components/common/Container';
import { RiArrowLeftSLine } from 'react-icons/ri';
import AppMainContainer from '../../containers/app/AppMainContainer';
import BannerRegistContainer from '../../containers/app/BannerRegistContainer';

const BannerRegistPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  const onClickBackButton = () => {
    history.goBack()
  }

  let history = useHistory();
  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer>
            <HistoryBlock>
              <HistoryBtn style={{marginBottom: '15px'}}><RiArrowLeftSLine onClick={() => onClickBackButton()}/></HistoryBtn>
              <NormalHistory style={{fontWeight: 'bold', marginBottom: '15px'}} >
                배너 제작
              </NormalHistory>
            </HistoryBlock>
            <BannerRegistContainer history={history}/>
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default BannerRegistPage;
